import React from 'react';
import styled from 'styled-components';

import { colorBlack900, colorPrimary } from 'styles';
import { Icon } from './CheckIcon';

const getSize = size => {
  switch (size) {
    case 'lg':
      return '36px';
    case 'md':
    default:
      return '24px';
  }
};

/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
export const Wrapper = styled(
  ({ bold, checkPosition, size, disabled, ...props }) => <label {...props} />
)`
  align-items: flex-start;
  color: ${colorBlack900};
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  position: relative;
  font-weight: ${({ bold }) => (bold ? '700' : 'normal')};

  ${({ checkPosition, size }) => {
    switch (checkPosition) {
      case 'start':
        return `padding-left: ${getSize(size)};`;
      case 'end':
      default:
        return `padding-right: ${getSize(size)};`;
    }
  }}

  &:hover,
  &.focus-visible {
    color: ${colorBlack900};
    text-decoration: none;

    ${/* sc-selector */ Icon}::before {
      border-color: ${({ disabled }) => (disabled ? '#ececec' : colorPrimary)};
    }
  }

  input:disabled + & {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
/* eslint-enable jsx-a11y/label-has-for */
/* eslint-enable jsx-a11y/label-has-associated-control */

export const Input = styled.input`
  display: none;
`;
